import React from "react";

export default function ONas() {
  return (
    <div
      className="min-h-screen"
      style={{
        background: "linear-gradient(135deg, #005d7e, #022e59, #fafafa)",
      }}
    >
      {/* HEADER */}
      <header className="relative z-10">
        <div className="max-w-7xl mx-auto px-5 py-6 flex justify-center">
          <a href="/">
            <img
              src="/e2fsilogo.png"
              alt="e2f.si"
              style={{ width: "160px" }}
            />
          </a>
        </div>
      </header>

      {/* HERO */}
      <section className="text-center px-5 pt-28 pb-40">
        <div className="max-w-4xl mx-auto text-white">
          <h1 className="text-4xl md:text-5xl font-semibold mb-6">
            Naša vizija
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            e2f.si – Ker je čas vaša najdragocenejša valuta.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-white rounded-t-[40px] -mt-24 pt-24 pb-24">
        <div className="max-w-5xl mx-auto px-5 space-y-24">

          {/* 1. NAŠA VIZIJA */}
          <div className="text-center">


            <h3 className="text-xl font-medium text-indigo-700 mb-6">
              e2f.si – Ker je čas vaša najdragocenejša valuta.
            </h3>

            <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
              V svetu digitalnega šuma smo ustvarili vstopno točko do najboljšega,
              kar ponuja slovensko gospodarstvo. Naša vizija je preprosta:
              postati najhitrejši in najbolj zanesljiv most med vašo potrebo
              in preverjeno lokalno rešitvijo.
              <br /><br />
              Verjamemo v kakovost, zato v ospredje postavljamo tiste,
              ki svojo profesionalnost dokazujejo z urejeno spletno prisotnostjo.
            </p>
          </div>

          {/* 2. KAKO DELUJE */}
          <div>
            <h2 className="text-3xl font-semibold text-gray-800 mb-4 text-center">
              Kako deluje
            </h2>

            <h3 className="text-xl font-medium text-indigo-700 mb-12 text-center">
              Do rešitve v treh preprostih korakih.
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
              <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-4">1</div>
                <p className="text-gray-600 text-lg leading-relaxed">
                  <strong>Vpišite ključno besedo:</strong> 
                  <br/>Naš iskalnik takoj
                  prepozna vašo potrebo.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-4">2</div>
                <p className="text-gray-600 text-lg leading-relaxed">
                  <strong>Izberite podkategorijo:</strong> Sistem vas usmeri
                  do natančne skupine ponudnikov.
                </p>
              </div>

              <div className="p-8 rounded-2xl bg-white border border-gray-100 shadow-sm text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-4">3</div>
                <p className="text-gray-600 text-lg leading-relaxed">
                  <strong>Obiščite ponudnika:</strong> Z enim klikom ste na
                  njihovi spletni strani ali drugem uradnem profilu, kjer lahko
                  takoj stopite v stik.
                </p>
              </div>
            </div>
          </div>

          {/* 3. ZAKAJ e2f.si */}
          <div className="text-center">
            <h2 className="text-3xl font-semibold text-gray-800 mb-4">
              Zakaj e2f.si?
            </h2>

            <h3 className="text-xl font-medium text-indigo-700 mb-6">
              Iskalnik, ki mu lahko zaupate.
            </h3>

            <p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
              Za razliko od avtomatiziranih imenikov, e2f.si temelji na ročno
              urejeni bazi podatkov. Vsak vpis je preverjen s strani naše ekipe.
              To pomeni, da ne boste izgubljali časa z neaktivnimi podjetji ali
              neobstoječimi storitvami.
              <br /><br />
              Pri nas dobite le tisto, kar je preverjeno, aktivno in slovensko.
            </p>
          </div>

        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-white px-5 py-16 pb-8">
        <div className="max-w-7xl mx-auto text-center">
          <img
            src="/e2fsilogo.png"
            alt="e2f.si"
            style={{ width: "100px" }}
            className="mx-auto mb-4"
          />

          <div className="border-t border-white/10 mt-10 pt-6 text-sm text-white/60">
            © {new Date().getFullYear()} e2f.si. Vse pravice pridržane.
          </div>
        </div>
      </footer>
    </div>
  );
}
